var RegisterOrganisationPage;
(function (RegisterOrganisationPage) {
    var MessageType;
    (function (MessageType) {
        MessageType[MessageType["Success"] = 0] = "Success";
        MessageType[MessageType["Warning"] = 1] = "Warning";
        MessageType[MessageType["Error"] = 2] = "Error";
    })(MessageType || (MessageType = {}));
    var RegisterStage;
    (function (RegisterStage) {
        RegisterStage[RegisterStage["User"] = 1] = "User";
        RegisterStage[RegisterStage["Organisation"] = 2] = "Organisation";
        RegisterStage[RegisterStage["Membership"] = 3] = "Membership";
        RegisterStage[RegisterStage["Service"] = 4] = "Service";
        RegisterStage[RegisterStage["Contact"] = 5] = "Contact";
        RegisterStage[RegisterStage["Submit"] = 6] = "Submit";
    })(RegisterStage || (RegisterStage = {}));
    var lastCheckedAbn = "";
    var addressMarker = null;
    function isPlatformMembership() {
        return $("input[name=Membership]:checked").val() === "Platform";
    }
    function updateMembershipFlow() {
        var platform = isPlatformMembership();
        $("#contactStepNumber").text(platform ? "4" : "5");
        $("#serviceCoordinatorPosition").toggle(!platform);
        if (platform) {
            $("#IsServiceCoordinator").prop("checked", false);
        }
    }
    function urlExists(element, url, cb) {
        if (!url.match("^http")) {
            url = "http://" + url;
        }
        $.ajax({
            url: "/Manage/Utilities/URLOk",
            data: JSON.stringify({ url: url }),
            dataType: "application/json",
            contentType: "application/json; charset=utf-8",
            type: "POST",
            success: cb,
            error: cb
        });
    }
    function setValidation(element, state) {
        var group = element.closest(".input-group");
        var addSpan = false;
        if (group.length) {
            addSpan = true;
            group.find(".mcd-error").remove();
            group.find(".mcd-success").remove();
            group.find(".mcd-validating").remove();
            group.find(".mcd-url-link").remove();
        }
        else {
            group = element;
        }
        group.removeClass("has-error");
        group.removeClass("has-success");
        if (state === "validating") {
            if (addSpan)
                group.append("<span class=\"input-group-addon mcd-validating\"><i class=\"fa fa-spinner fa-spin fa-fw\"></i></span>");
            element.trigger("mcd:editor-validating");
        }
        else if (state === "success") {
            if (addSpan)
                group.append("<span class=\"input-group-addon mcd-success\"><i class=\"fa fa-check fa-fw\"></i></span>");
            group.addClass("has-success");
            element.trigger("mcd:editor-valid");
        }
        else if (state === "error") {
            if (addSpan)
                group.append("<span class=\"input-group-addon mcd-error\"><i class=\"fa fa-times fa-fw\"></i></span>");
            group.addClass("has-error");
            element.trigger("mcd:editor-error");
        }
        else if (state === "empty") {
            element.trigger("mcd:editor-valid");
        }
    }
    function validateField(element, isPhone) {
        setValidation(element, "validating");
        // trigger once to fire off any validation errors
        element.valid();
        if (!element.val()) {
            setValidation(element, "empty");
            return false;
        }
        if (element.valid()) {
            if (isPhone) {
                Common.FormatAsAusPhone(element, element.data("state"));
            }
            setValidation(element, "success");
            return true;
        }
        else {
            setValidation(element, "error");
        }
        return false;
    }
    function validateUrlField(element, pretext) {
        setValidation(element, "validating");
        if (element.valid() && element.val()) {
            urlExists(element, pretext + element.val(), function (result) {
                if (result.responseText === "True") {
                    if (!(pretext + element.val()).match("^http")) {
                        element.val("http://" + element.val());
                    }
                    setValidation(element, "success");
                    element.closest(".input-group").append("<span class=\"input-group-addon mcd-url-link \"><a href=\"" + pretext + element.val() + "\" target=\"_blank\"><i class=\"fa fa-external-link fa-fw\"></i></a></span>");
                }
                else {
                    setValidation(element, "error");
                }
            });
        }
        else {
            if (element.val()) {
                setValidation(element, "error");
            }
            else {
                setValidation(element, "empty");
            }
        }
    }
    function showMessages(messages) {
        if (messages && messages.length) {
            messages.forEach(function (msg) {
                var msgType = "danger";
                var msgTitle = "Error";
                switch (msg.MessageType) {
                    case MessageType.Success:
                        msgTitle = "Success";
                        msgType = "success";
                        break;
                    case MessageType.Warning:
                        msgTitle = "Warning";
                        msgType = "warning";
                        break;
                }
                $.notify({ title: msgTitle, message: msg.Message, icon: "glyphicon glyphicon-remove-circle" }, { type: msgType });
            });
        }
    }
    function showFieldLength() {
        var section = $(this).closest(".input-maxlen");
        var input = section.find("input, textarea");
        var count = section.find(".text-count");
        var maxlen = input.prop("maxlength");
        if (!count.is(":visible")) {
            var textFunc = function () {
                var text = input.val();
                var displayText = "";
                if (text.length) {
                    var words = text.split(" ");
                    var wordCount = 0;
                    for (var i = 0; i < words.length; i++) {
                        if (words[i] !== "") {
                            wordCount++;
                        }
                    }
                    var wordText = wordCount === 1 ? " word, " : " words, ";
                    displayText = wordCount.toLocaleString() + wordText;
                    var charCount = text.length;
                    var charType = "";
                    if (maxlen > 0) {
                        charCount = maxlen - text.length;
                        if (charCount < 0)
                            charCount = 0;
                        charType = " remaining";
                    }
                    var charText = charCount === 1 ? " character" : " characters";
                    displayText += charCount.toLocaleString() + charText + charType;
                }
                else if (maxlen > 0) {
                    displayText = maxlen.toLocaleString() + " characters allowed";
                }
                count.text(displayText);
            };
            textFunc();
            count.show();
            input.on("keyup", textFunc);
            section.one("blur", function () {
                setTimeout(function () {
                    // Delay hide to stop click events being eaten in Chrome caused by the dom changes
                    count.hide();
                }, 100);
                input.off("keyup", textFunc);
            });
        }
    }
    function setSectionComplete(section) {
        section.addClass("section-complete");
        section.find("input:not(.toggle), textarea").prop("readonly", true);
        section.find("select, input[type=checkbox]").prop("disabled", true);
        section.find("div.toggle").hide().closest(".checkbox-inline").addClass("padding-left-0");
        if (section.is("#membershipDetails")) {
            section.find(".btn-next").show();
        }
    }
    function afterSectionDisplay(stage) {
        if (stage === RegisterStage.Organisation) {
            var lat = parseFloat($("#Latitude").val());
            var lng = parseFloat($("#Longitude").val());
            if (lat && lng) {
                showAddressDisplay(new google.maps.LatLng(lat, lng));
            }
        }
    }
    function setSectionCurrent(stage, scroll) {
        var newSection = $(".register-section-" + stage);
        if (stage === RegisterStage.Submit) {
            $("#alert-terms").slideDown(200, function () {
                $("#btnSave").prop("disabled", false);
            });
        }
        else {
            newSection.removeClass("section-disabled").show();
        }
        var firstField = newSection.find("input:visible, textarea:visible, select:visible, button:visible, [tabindex=0]:visible").first();
        firstField.focus();
        if (scroll) {
            var offset = newSection.offset();
            $('html, body').animate({
                scrollTop: offset.top - 5
            }, 400, function () {
                afterSectionDisplay(stage);
            });
        }
        else {
            afterSectionDisplay(stage);
        }
    }
    function clearStreetAddress() {
        $("#StreetAddress").val("");
        $("#AddressBuilding").val("");
        $("#Address1").val("");
        $("#Address2").val("");
        $("#Suburb").val("");
        $("#State").val("");
        $("#Postcode").val("");
        $("#Latitude").val("");
        $("#Longitude").val("");
        if ($("#address-display").is(":visible")) {
            $("#address-display").slideUp(100, function () {
                $("#address-entry").slideDown(300);
            });
        }
    }
    function setupAddressMap(latLng) {
        if (!$("#address-map-container").is(":visible"))
            return;
        if (addressMarker === null) {
            var addrWidth = $("#street-address-fields").width();
            var addrHeight = $("#street-address-fields").height();
            var mapWidth = $("#address-map-container").width();
            var mapHeight = $("#address-map-container").height();
            if (mapWidth < addrWidth && addrHeight > mapHeight) {
                $("#AddressMap").css("height", addrHeight);
            }
            Common.Map.InitMap("#AddressMap", latLng);
            addressMarker = Common.Map.AddMarker("#AddressMap", latLng, { title: 'Your Location', draggable: false });
        }
        else {
            Common.Map.SetCentre("#AddressMap", latLng);
            Common.Map.SetMarker(addressMarker, latLng);
        }
    }
    function showAddressDisplay(latLng) {
        if ($("#address-entry").is(":visible")) {
            $("#address-entry").slideUp(100, function () {
                $("#address-display").slideDown(300, function () {
                    $("#AddressBuilding").focus();
                    setupAddressMap(latLng);
                });
            });
        }
        else {
            setupAddressMap(latLng);
        }
    }
    function abnValidate(value, element) {
        var trimValue = value.replace(/[^0-9]/g, '');
        if (trimValue.length != 11 || isNaN(parseInt(trimValue)))
            return false;
        var weighting = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
        var tally = (parseInt(trimValue[0]) - 1) * weighting[0];
        for (var i = 1; i < trimValue.length; i++) {
            tally += (parseInt(trimValue[i]) * weighting[i]);
        }
        return (tally % 89) == 0;
    }
    function Init(campaign) {
        $(function () {
            if (campaign) {
                $("body").on("click", ".register-btn", function () {
                    var href = $(this).attr('href');
                    var campaignStr = "";
                    if (href.indexOf("?") > 0) {
                        campaignStr = "&campaign=" + campaign;
                    }
                    else {
                        campaignStr = "?campaign=" + campaign;
                    }
                    $(this).attr('href', href + campaignStr);
                });
            }
            $(".hidden").hide().removeClass("hidden");
            updateMembershipFlow();
            $(".membership-choice").change(updateMembershipFlow);
            setSectionComplete($(".section-complete"));
            var initStage = parseInt($("#Stage").val());
            if (initStage) {
                if (initStage > RegisterStage.User) {
                    $(".register-section-" + RegisterStage.User).find("input, select").prop("required", false);
                }
                setTimeout(function () {
                    setSectionCurrent(initStage, false);
                }, 500);
            }
            $.validator.setDefaults({
                highlight: function (element) {
                    $(element).attr("aria-invalid", "true");
                    var group = $(element).closest('.input-group');
                    if (group.length) {
                        group.addClass('has-error');
                    }
                    else {
                        $(element).addClass('has-error');
                    }
                },
                unhighlight: function (element) {
                    $(element).attr("aria-invalid", "false");
                    var group = $(element).closest('.input-group');
                    if (group.length) {
                        group.removeClass('has-error');
                    }
                    else {
                        $(element).removeClass('has-error');
                    }
                },
                errorElement: 'span',
                errorClass: 'help-block',
                errorPlacement: function (error, element) {
                    var group = $(element).closest('.input-group');
                    if (group.length) {
                        error.insertAfter(group);
                    }
                    else {
                        error.insertAfter(element);
                    }
                }
            });
            jQuery.validator.addMethod('abnValidate', abnValidate, 'The ABN is not valid');
            $.validator.addClassRules("mcd-email-input", {
                mcdEmail: true
            });
            $.validator.addClassRules("mcd-mobile-input", {
                ausMobile: true
            });
            $.validator.addClassRules("mcd-phone-input", {
                ausPhone: true
            });
            $.validator.addClassRules("mcd-url-input", {
                simpleUrl: true
            });
            $.validator.addClassRules("mcd-abn-input", {
                abnValidate: true
            });
            $(".btn-thirdPartySelect").click(function (e) {
                e.preventDefault();
                var provider = $(this).data("provider");
                $("#" + provider).click();
            });
            $("#registerForm").validate({
                rules: {
                    Email: {
                        require_from_group: [1, ".org-access"]
                    },
                    Phone: {
                        require_from_group: [1, ".org-access"]
                    },
                    ContactEmail: {
                        require_from_group: [1, ".contact-access"]
                    },
                    ContactPhone: {
                        require_from_group: [1, ".contact-access"]
                    },
                    ContactMobile: {
                        require_from_group: [1, ".contact-access"]
                    },
                    Description: {
                        required: true,
                        minlength: 40,
                        maxlength: 400
                    }
                },
                messages: {
                    Email: { require_from_group: "A method of contact is required" },
                    Phone: { require_from_group: "A method of contact is required" },
                    ContactEmail: { require_from_group: "A method of contact is required" },
                    ContactPhone: { require_from_group: "A method of contact is required" },
                    ContactMobile: { require_from_group: "A method of contact is required" },
                }
            });
            $("input, textarea, select.required").on("blur", function () {
                if ($(this).is(".mcd-phone-input, .mcd-mobile-input")) {
                    validateField($(this), true);
                }
                else if ($(this).is(".mcd-url-input")) {
                    validateUrlField($(this), "");
                }
                else {
                    validateField($(this), false);
                }
            });
            $("#ABN").blur(function (e) {
                if (validateField($(this), false)) {
                    var trimValue = $(this).val().replace(/[^0-9]/g, '');
                    var newValue = trimValue.substr(0, 2) + " " + trimValue.substr(2, 3) + " " + trimValue.substr(5, 3) + " " + trimValue.substr(8, 3);
                    $(this).val(newValue);
                    if (lastCheckedAbn !== newValue) {
                        lastCheckedAbn = newValue;
                        $("#existingOrganisation").slideUp(100);
                        setValidation($(this), "validating");
                        var newState = "error";
                        $.ajax({
                            url: "/Directory/Register/ValidateABN?abn=" + trimValue,
                            type: "POST",
                            dataType: "json",
                            success: function (response) {
                                showMessages(response.Messages);
                                if (response.Success) {
                                    newState = "success";
                                    $("#OrganisationName").val(response.OrganisationName);
                                    if (response.HaveAddress) {
                                        var streetAddress = response.Address1;
                                        if (response.Address2) {
                                            if (streetAddress.length)
                                                streetAddress += ", ";
                                            streetAddress += response.Address2;
                                        }
                                        if (response.Suburb) {
                                            if (streetAddress.length)
                                                streetAddress += ", ";
                                            streetAddress += response.Suburb;
                                        }
                                        if (response.State) {
                                            if (streetAddress.length)
                                                streetAddress += ", ";
                                            streetAddress += response.State;
                                        }
                                        if (response.Postcode) {
                                            if (streetAddress.length)
                                                streetAddress += ", ";
                                            streetAddress += response.Postcode;
                                        }
                                        $("#StreetAddress").val(streetAddress);
                                        $("#AddressBuilding").val(response.AddressBuilding);
                                        $("#Address1").val(response.Address1);
                                        $("#Address2").val(response.Address2);
                                        $("#Suburb").val(response.Suburb);
                                        $("#State").val(response.State);
                                        $("#Postcode").val(response.Postcode);
                                        $("#Latitude").val(response.Latitude);
                                        $("#Longitude").val(response.Longitude);
                                        showAddressDisplay(new google.maps.LatLng(response.Latitude, response.Longitude));
                                    }
                                    $("#Phone").val(response.Phone);
                                    $("#Email").val(response.Email);
                                    $("#Website").val(response.Website);
                                    if (response.PrimaryCategoryGroupID) {
                                        $(".category[data-id=" + response.PrimaryCategoryGroupID + "]").click();
                                    }
                                    if (response.PrimaryCategoryID) {
                                        $(".service[data-id=" + response.PrimaryCategoryID + "]").click();
                                    }
                                    if (response.Description) {
                                        $("#Description").val(response.Description);
                                    }
                                    if (response.ExistingOrganisation) {
                                        $("#existingOrganisation").slideDown(300);
                                    }
                                }
                            },
                            error: function () {
                                $.notify({ title: "Error", message: "There was an unexpected error, please try again later.", icon: "glyphicon glyphicon-remove-circle" }, { type: "danger" });
                            },
                            complete: function () {
                                setValidation($("#ABN"), newState);
                            }
                        });
                    }
                }
            });
            if ($("#ABN").val()) {
                $("#ABN").trigger("blur");
            }
            $("#HaveABN").change(function () {
                if ($("#HaveABN").is(":checked")) {
                    $("#HaveABNLabel").addClass("required");
                    $("#HaveABNLabel .label-text").text("We have an ABN");
                    $("#ABN").closest(".input-group").show(300);
                }
                else {
                    $("#ABN").closest(".input-group").hide(300, function () {
                        $("#HaveABNLabel").removeClass("required");
                        $("#HaveABNLabel .label-text").text("We don't have an ABN");
                    });
                    $("#ABN-error").hide();
                }
            });
            var selector = "div[data-toggle^=toggle]";
            $(".accessible-toggle").on("keydown", function (e) {
                if (e.which === 13) {
                    e.stopImmediatePropagation();
                    $(selector, this).trigger("click.bs.toggle");
                }
            });
            $(".accessible-toggle").on("click", function (e) {
                e.stopImmediatePropagation();
                $(selector, this).trigger("click.bs.toggle");
            });
            $(document).on("click.bs.toggle", selector, function (e) {
                var $parent = $(e.target).closest(".accessible-toggle");
                $parent.closest(".accessible-toggle").attr("aria-checked", $("input[type=checkbox]", $parent).is(":checked") ? "true" : "false");
            });
            $("#IsUserContact").change(function () {
                if ($("#IsUserContact").is(":checked")) {
                    $("#IsUserContactLabel .label-text").text("You are the key contact");
                    $("#altContactDetails").slideUp(300);
                }
                else {
                    $("#IsUserContactLabel .label-text").text("You are not the key contact");
                    $("#altContactDetails").slideDown(300);
                }
            });
            Common.Map.InitAutoComplete("#StreetAddress");
            $("#StreetAddress").on("mcd:autocomplete", function (e, data) {
                if (data && data.location && data.location.latLng) {
                    $("#Address1").val(data.location.address);
                    $("#Address2").val("");
                    $("#Suburb").val(data.location.suburb);
                    $("#State").val(data.location.state);
                    $("#Postcode").val(data.location.postcode);
                    $("#Latitude").val(data.location.latLng.lat());
                    $("#Longitude").val(data.location.latLng.lng());
                    showAddressDisplay(data.location.latLng);
                }
                else {
                    clearStreetAddress();
                }
            });
            $("#change-address").click(function () {
                clearStreetAddress();
                setTimeout(function () { return $("#StreetAddress").focus(); }, 500);
            });
            function triggerCategoryClick(elem) {
                if ($(elem).closest(".register-section").hasClass("section-complete"))
                    return;
                var id = $(elem).data("id");
                if (id !== $("#PrimaryCategoryGroupID").val()) {
                    $("#PrimaryCategoryGroupID").val(id);
                    $("#PrimaryCategoryID").val("");
                    $(".category-picker").addClass("has-selected");
                    $(".category.selected").removeClass("selected");
                    $(elem).addClass("selected");
                    $(elem).attr("aria-selected", "true");
                    var showNewServices = function () {
                        $(".service-picker .selected").removeClass(".selected");
                        $(".service-picker").removeClass("has-selected");
                        var services = $(".service-picker-" + id + " .service");
                        if (services.length === 1) {
                            services.click();
                        }
                        else {
                            $(".service-picker-" + id).slideDown(300, function () { return $(".service-picker-".concat(id, " .service:first")).focus(); });
                        }
                    };
                    if ($(".service-picker").is(":visible")) {
                        $(".service-picker:visible").slideUp(300, showNewServices);
                    }
                    else {
                        showNewServices();
                    }
                }
            }
            $(".category").on("click touchend", function () {
                triggerCategoryClick(this);
            });
            $(".category").on("keyup", function (ev) {
                if (ev.which === 13) {
                    triggerCategoryClick(this);
                }
            });
            function triggerServiceClick(elem) {
                if ($(elem).closest(".register-section").hasClass("section-complete"))
                    return;
                var id = $(elem).data("id");
                if (id !== $("#PrimaryCategoryID").val()) {
                    $("#PrimaryCategoryID").val(id);
                    $(".service.selected").removeClass("selected");
                    $(elem).addClass("selected");
                    $(elem).closest(".service-picker").addClass("has-selected");
                    $(elem).attr("aria-selected", "true");
                    $("#Description").focus();
                }
            }
            $(".service").on("click touchend", function () {
                triggerServiceClick(this);
            });
            $(".service").on("keyup", function (ev) {
                if (ev.which === 13) {
                    triggerServiceClick(this);
                }
            });
            if ($(".category").length == 1 && $(".service").length == 1) {
                $(".category").trigger("click");
                $(".service").trigger("click");
                $(".category-picker").hide();
            }
            $(".input-maxlen textarea").on("focus", showFieldLength);
            $(".btn-next").click(function () {
                var btn = $(this);
                var section = btn.closest(".register-section");
                var inputFields = section.find("input, textarea, select");
                var isMembershipSection = section.is("#membershipDetails");
                if (!section.hasClass("section-disabled") &&
                    (!section.hasClass("section-complete") || isMembershipSection) &&
                    (inputFields.length === 0 || inputFields.valid())) {
                    if (isMembershipSection) {
                        $("#Stage").val(RegisterStage.Membership);
                    }
                    if (parseInt($("#Stage").val()) === RegisterStage.Organisation && !$("#address-display").is(":visible")) {
                        $.notify({ title: "Error", message: "Please select an address from the drop-down list to proceed.", icon: "glyphicon glyphicon-remove-circle" }, { type: "danger" });
                        $("#StreetAddress").focus();
                        return;
                    }
                    var spinner = null;
                    btn.prop("disabled", true);
                    var disabledControls = $("select:disabled, input:disabled");
                    disabledControls.prop("disabled", false);
                    var data = $("#registerForm").serialize();
                    disabledControls.prop("disabled", true);
                    var timer = setTimeout(function () {
                        spinner = btn.prepend("<i class='fa fa-cog fa-spin'></i> ").find("i");
                    }, 1000);
                    var resetButton = true;
                    $.ajax({
                        url: "/Directory/Register/Progress",
                        data: data,
                        type: "POST",
                        dataType: "json",
                        success: function (response) {
                            showMessages(response.Messages);
                            if (response.Success) {
                                $(".stage-response-" + response.Stage).slideUp(100);
                                switch (response.Stage) {
                                    case RegisterStage.User:
                                        if (response.ExistingUser) {
                                            // The user already has a login
                                            $("#existingUser").slideDown(300);
                                        }
                                        else if (response.ExistingOrganisation) {
                                            // The user is linked to an organisation, but doesn't have a login yet
                                            $("#existingUserOrganisation").slideDown(300);
                                        }
                                        break;
                                    case RegisterStage.Organisation:
                                        if (response.ExistingOrganisation) {
                                            // The organisation exists
                                            $("#OrganisationName").focus();
                                            $("#existingOrganisation").slideDown(300);
                                        }
                                        if (response.PrimaryCategoryGroupID) {
                                            $(".category[data-id=" + response.PrimaryCategoryGroupID + "]").click();
                                        }
                                        if (response.PrimaryCategoryID) {
                                            $(".service[data-id=" + response.PrimaryCategoryID + "]").click();
                                        }
                                        if (response.Description) {
                                            $("#Description").val(response.Description);
                                        }
                                        break;
                                    case RegisterStage.Membership:
                                        if (response.NextStage === RegisterStage.Contact) {
                                            $(".register-section-" + RegisterStage.Service).hide();
                                        }
                                        break;
                                }
                                if (response.Stage !== response.NextStage) {
                                    setSectionComplete($(".register-section-" + response.Stage));
                                    $("#Stage").val(response.NextStage);
                                    setSectionCurrent(response.NextStage, true);
                                }
                                if (response.RedirectUrl) {
                                    resetButton = false;
                                    location.assign(response.RedirectUrl);
                                }
                            }
                        },
                        error: function () {
                            $.notify({ title: "Error", message: "There was an unexpected error, please try again later.", icon: "glyphicon glyphicon-remove-circle" }, { type: "danger" });
                        },
                        complete: function () {
                            if (resetButton) {
                                btn.prop("disabled", false);
                                clearTimeout(timer);
                                if (spinner)
                                    spinner.remove();
                            }
                        }
                    });
                }
                if (!inputFields.valid()) {
                    $("[aria-invalid=true]:first", section).focus();
                }
            });
        });
    }
    RegisterOrganisationPage.Init = Init;
})(RegisterOrganisationPage || (RegisterOrganisationPage = {}));
